module.exports = __webpack_public_path__ + "img/dd.91e81771.png";